module.exports = __webpack_public_path__ + "img/icon-edit-medium.29fe9e12.svg";